/* eslint-disable react/prop-types */
import { Box } from '@mui/material';
import ShippingIcon from '@mui/icons-material/LocalShipping';
import { forwardRef } from 'react';

// POM-6516: one tooltip wording for the batch truck on every screen. Business batches lead with
// "Business address" to match the solo "B"; "Click to view the batch." only where the truck opens it.
export const batchShippingTooltip = ({ isBusinessAddress, isShipped, isClickable }) =>
  [
    isBusinessAddress && 'Business address ·',
    isShipped ? 'Shipped as part of a batch.' : 'In batch shipment queue.',
    isClickable && 'Click to view the batch.',
  ]
    .filter(Boolean)
    .join(' ');

// `rest` carries the hover/focus handlers and aria props a wrapping MUI Tooltip injects; without
// them the truck's tooltip never opens.
const BatchShippingIcon = forwardRef(({ color, onClick, sx, showBadge = false, ...rest }, ref) => (
  <Box
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
    ref={ref}
    sx={{
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: onClick ? 'pointer' : 'default',
      ...sx,
    }}
    onClick={onClick}
  >
    <ShippingIcon sx={{ color, fontSize: 24 }} />
    {showBadge && (
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '42%',
          transform: 'translate(-50%, -50%)',
          fontSize: '9px',
          fontWeight: 'bold',
          color: 'white',
          textShadow: `
            -1px -1px 0 ${color || '#000'},
            1px -1px 0 ${color || '#000'},
            -1px 1px 0 ${color || '#000'},
            1px 1px 0 ${color || '#000'}
          `,
          userSelect: 'none',
        }}
      >
        B
      </Box>
    )}
  </Box>
));

export default BatchShippingIcon;
